/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a good keyword density?`)
};

const es_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es una buena densidad de palabras clave?`)
};

const de_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine gute Schlüsselwortdichte?`)
};

const nl_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een goede trefwoorddichtheid?`)
};

const fr_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est une bonne densité de mots-clés ?`)
};

const it_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è una buona densità di parole chiave?`)
};

const pt_br2_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é uma boa densidade de palavras-chave?`)
};

const pt_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é uma boa densidade de palavras-chave?`)
};

const ja_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`良いキーワード密度とは何ですか？`)
};

const zh_wc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多少关键词密度算合适？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_faq4_q", locale)
	if (locale === "en") return en_wc_faq4_q(inputs)
	if (locale === "es") return es_wc_faq4_q(inputs)
	if (locale === "de") return de_wc_faq4_q(inputs)
	if (locale === "nl") return nl_wc_faq4_q(inputs)
	if (locale === "fr") return fr_wc_faq4_q(inputs)
	if (locale === "it") return it_wc_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_wc_faq4_q(inputs)
	if (locale === "pt") return pt_wc_faq4_q(inputs)
	if (locale === "ja") return ja_wc_faq4_q(inputs)
	return zh_wc_faq4_q(inputs)
};